module.exports = __webpack_public_path__ + "static/services-2-5a7c7b280d016239c0a9712bc088454c.jpg";